import { Pipe, PipeTransform } from "@angular/core";
import { AssetClass } from "../enums/asset-class.enum";

@Pipe({ name: "assetClass" })
export class AssetClassPipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    switch (value as AssetClass) {
      case AssetClass.MobileMoney:
        return "Mobile Money";
      case AssetClass.Crypto:
        return "Crypto";
      default:
        return value != null ? String(value) : "—";
    }
  }
}
